<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i
          class="material-icons"
          id="menu-toggle"
          @click="isSidebar =  !isSidebar"
          >view_headline</i
        >
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <div class="row">
            <div class="col-sm-12">
              <vs-breadcrumb
                align="left"
                :items="
                  [
                  {title: 'You are here : '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/Trainee/traineeDashboard'
                    },
                    {
                      title: 'Post Assesment',
                      url: '/#/dashboard/Trainee/postassessment',
                      active: true
                    }
                  ]"
              ></vs-breadcrumb>
              <div class="row">
                <div class="col-md-12">
                  <div></div>
                  <div class="container mt-3">
                    <div class="questionScreen d-flex flex-column">
                      <div class="d-flex p-2">
                        <div class="training-code pr-2">
                          <h6 class="training-code-clr">T001</h6>
                        </div>
                        <div class="training-title">
                          <h6>{{trainingDetails.title}}</h6>
                          <small
                            >{{formatDate(trainingDetails.startdate)}} -
                            {{formatDate(trainingDetails.enddate)}}</small
                          >
                          <p>{{trainingDetails.address}}</p>
                        </div>
                      </div>
                      <div class="pl-3 mb-2">
                        <h5>Post Assessment</h5>
                      </div>
                      <template v-if="submittedStatus == 0">
                        <form @submit.prevent="preassesmentfeedback">
                          <div class="progress-indicator" v-if="feedbackQuestions.length > 0">
                            <div class="progress-text mr-3">
                              <span class="font-weight-bold">{{currentQ + 1}}</span> of {{feedbackQuestions.length}}
                            </div>
                            <div class="progress-bar">
                              <div class="progress-fill" :style="{width: ((currentQ + 1) / feedbackQuestions.length * 100) + '%'}"></div>
                            </div>
                          </div>
                          
                          <div class="question" v-if="feedbackQuestions.length > 0">
                            <input type="hidden" v-model="training_id" />
                            <div class="question-header">
                              <h6 v-if="feedbackQuestions[currentQ] != undefined && feedbackQuestions[currentQ].qtitle != undefined">
                                Question {{currentQ+1}} of {{feedbackQuestions.length}}
                              </h6>
                            </div>
                            <p class="question-text">
                              <b>{{currentQ+1}}) {{feedbackQuestions[currentQ].qtitle}} {{feedbackQuestions[currentQ].question}}</b>
                            </p>
                          </div>
                          <div v-else>
                            <div class="alert alert-info">
                              <h6 class="text-center mb-0">No Post Assessment Found</h6>
                            </div>
                          </div>
                          
                          <div class="options">
                            <p class="text-muted">
                              <i class="fas fa-info-circle mr-2"></i>Select your answer below
                            </p>
                            <ul class="options-list">
                              <li
                                class="option-item"
                                v-for="(options,index) in feedbackQuestionOptions"
                                :key="index"
                                :class="{ 'active': options.oquestionBank_id === feedbackQuestions[currentQ].qid }"
                              >
                                <template
                                  v-if="options.oquestionBank_id === feedbackQuestions[currentQ].qid"
                                >
                                  <vs-radio
                                    v-model="selectedOptions[currentQ].answer"
                                    :vs-value="options.oid"
                                    class="option-radio"
                                  >{{options.otitle}}</vs-radio>
                                </template>
                              </li>
                            </ul>
                            
                            <div class="button-container" v-if="selectedOptions !=''">
                              <b-button
                                type="submit"
                                class="next-btn"
                                variant="primary"
                                v-if="currentQ+1 == feedbackQuestions.length && selectedOptions[feedbackQuestions.length - 1].answer !=''"
                              >
                                <i class="fas fa-check mr-2"></i>Submit Assessment
                              </b-button>

                              <b-button
                                v-else-if="selectedOptions[currentQ].answer !=''"
                                class="next-btn"
                                variant="primary"
                                @click="next()"
                              >
                                Next Question <i class="fas fa-arrow-right ml-2"></i>
                              </b-button>
                            </div>
                          </div>
                        </form>
                      </template>
                      <template v-else>
                        <div class="completed-message">
                          <div class="alert alert-success text-center">
                            <i class="fas fa-check-circle fa-2x mb-3"></i>
                            <h6 class="mb-0">You have successfully submitted your Post Assessment</h6>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr style="border:1px solid #dedede;opacity:0.4" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";

import "bootstrap/dist/css/bootstrap.css";
// Import date picker css
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import axios from "axios";
import { formatDate } from "@/utils/DateFormate";

export default {
  data: () => ({
    isSidebar: false,
    indexActive: 0,
    trainingDetails: "",
    training_id: "",
    submittedStatus: "",
    TrainingDates: [],
    feedbackQuestions: [],
    feedbackQuestionOptions: [],
    selectedOptions: [],
    checkBox1: false,
    checkBox2: false,
    checkBox3: false,
    checkBox4: false,
    radios1: "false",
    radios2: "false",
    //questions: [],
    currentQ: 0,
    trainingCode: "",
    referenceCount : 0,

  }),
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    let self = this;
    this.trainingCode = this.$route.query.training;
    this.openLoading();
    axios
      .get(
        process.env.VUE_APP_BASE_PATH +
          "/get/trainee/trainingdetails/" +
          this.trainingCode

        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        if (response.data) {
          self.trainingDetails = response.data;
          self.training_id = response.data.id;
          self.checkPostAssessment(self.training_id);
          if(response.data.disableReference == false){
              axios
              .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/references/counts/" +
                    response.data.id + "/" + JSON.parse(localStorage.getItem("currentUser")).id
                )
                .then(response => {
                    this.referenceCount = response.data.count

                    if(response.data.count < 2){
                      this.$router.push({
                             path: '/dashboard/Trainee/addReference',
                             query: { training: this.trainingDetails }
                         });

                    }
                })
          }

        }
      });


  },
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  },
  methods: {
    formatDate,
    checkPostAssessment: function checkPostAssessment(trId) {
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/check/trainee/post-assesment/" +
            JSON.parse(localStorage.getItem("currentUser")).id +
            "/" +
            trId

        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          if (response.data) {
            this.submittedStatus = response.data.count;
            this.allQuestions(trId);
          }
        });
    },
    allQuestions: function allQuestions(traingId) {
      this.openLoading();
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/trainee/training/post-assessment-feedback/get/" +
            JSON.parse(localStorage.getItem("currentUser")).id +
            "/" +
            traingId

        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.feedbackQuestions = response.data["questionArray"];
          for (var i = 0; i < this.feedbackQuestions.length; i++) {
            this.selectedOptions.push({
              lengthh: i,
              answer: "",
              assesmentID: this.feedbackQuestions[i].assesmentID,
              quid: this.feedbackQuestions[i].qid
            });
          }
          this.feedbackQuestionOptions = response.data["optionArray"][0];
        });
    },
    preassesmentfeedback(e) {
      e.preventDefault();
      this.inValid = [];
      let self = this;
      this.selectedOptions.forEach(element => {
        if (element.answer == "") {
          this.inValid.push("Please select an option.");
        }
      });
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        this.openLoading();
        axios
          .post(
            process.env.VUE_APP_BASE_PATH +
              "/trainee/postassesment/feedback/save",
            {
              feedback: this.selectedOptions,
              trainee_id:
                JSON.parse(localStorage.getItem("currentUser")).id + "",
              training_id: this.training_id
            }
          )
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Post Assesment Submitted Successfully!");
              this.submittedStatus = 1;
              // self.$router.go();
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    toastSuccess(msg) {
      this.$bvToast.toast(msg, {
        title: "Success",
        autoHideDelay: 10000,
        variant: "success",
        solid: true
      });
    },
    toastError(msg) {
      this.$bvToast.toast(msg, {
        title: "Error",
        autoHideDelay: 10000,
        variant: "danger",
        solid: true
      });
    },
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    showForm() {
      this.isForm = false;
      this.isFormData = true;
    },
    formSubmitted() {
      alert("Form submitted!");
    },
    next: function() {
      if (this.currentQ + 1 < this.feedbackQuestions.length) {
        this.currentQ++;
      }
    }
  }
};
</script>
<style>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
.questionScreen{
  border: none !important;
  background-color: #ffffff !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 1rem;
  max-width: 900px;
  margin: 0 auto 2rem;
}
.training-code-clr{
  color: #6c757d;
  font-weight: 600;
  font-size: 1rem;
}
.question h6{
  text-decoration: none !important;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 1rem;
}
li {
  list-style-type: none !important;
}
.feedback_submitted {
  text-align: center;
}
.f-500 {
  font-weight: 500;
}
.dblock {
  display: block !important;
}
.input-color {
  margin-bottom: 10px;
  position: relative;
  display: block;
}
.myNavbar {
  color: rgb(255, 255, 255);
}
.dflex {
  display: flex;
}
.fcenter {
  justify-content: center;
  align-items: center;
}
.pleft-5 {
  margin-left: 5px;
}
.selectExample {
  margin: 10px;
}
.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
}
.con-select .vs-select {
  width: 100%;
}
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%;
  }
  .container.mt-3 {
    margin-top: 0px !important;
  }
}

.form-row {
  padding: 8px;
  color: #1465a3;
  border: 1px dotted #07a7e14f;
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.field {
  width: 100%;
  text-transform: capitalize;
  border-bottom: 2px solid #d0d0d0;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  transition: all 0.2s ease-in-out 0.2s;
  -webkit-transition: all 0.2s ease-in-out 0.2s;
  -moz-transition: all 0.2s ease-in-out 0.2s;
}
.sub-frm-title {
  padding: 5px;
  background-color: #fff;
  margin-top: -25px;
  text-align: center;
  color: rgba(7, 167, 225, 0.61);
}
/* overide css of vuesax */
.vs-con-input-label {
  width: 100% !important;
}
.vs-con-input-label.is-label-placeholder {
  margin-top: 8px !important;
}
.frm-title {
  text-align: center;
  padding: 10px;
  color: #009ad2;
  /* border-bottom: 2px solid #009ad2; */
}
.next-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  float: right;
  margin: 10px 0px;
}
.add-locations-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  margin: 10px 0px;
}
.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
}

.new-training {
  padding-right: 10px;
}
.title-text {
  margin-bottom: 0px;
}
.selectize-control.multi .selectize-input > div {
  background: rgba(7, 167, 225, 0.61);
  color: #333333;
}
.con-select {
  font-size: 0.85rem !important;
}
.selectize-input.items.not-full.has-options.has-items {
  font-size: 0.85rem !important;
}

/* Floating label css starts */
/****  floating-Lable style start ****/
.floating-label {
  position: relative;
  margin-bottom: 5px;
}
.floating-input,
.floating-select {
  font-size: 14px;
  padding: 4px 30px 4px 5px;
  display: block;
  width: 100%;
  height: 36px;
  box-shadow: none !important;
  /* background-color: transparent; */
  border: none;
  border: 1px solid #ccc;
}

.floating-input:focus,
.floating-select:focus {
  outline: none;
  border: 2px solid rgba(7, 167, 225, 0.61);
}

label.lbl-label {
  color: #ccc;
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 6px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

.floating-input:focus ~ label.lbl-label,
.floating-input:not(:placeholder-shown) ~ label.lbl-label {
  background-color: #f9f9f9;
  /* background-color: #fff; */
  top: -12px;
  left: 10px;
  font-size: 14px;
  color: rgba(7, 167, 225, 0.61);
  padding: 0px 5px;
}

.floating-select:focus ~ llabel.lbl-label,
.floating-select:not([value=""]):valid ~ label.lbl-label {
  top: -18px;
  font-size: 14px;
  color: #5264ae;
}

/* active state */
.floating-input:focus ~ .bar:before,
.floating-input:focus ~ .bar:after,
.floating-select:focus ~ .bar:before,
.floating-select:focus ~ .bar:after {
  width: 50%;
}

*,
*:before,
*:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

/* highlighter */
/* .highlight {
  position: absolute;
  height: 50%;
  width: 100%;
  top: 15%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
} */

/* active state */
.floating-input:focus ~ .highlight,
.floating-select:focus ~ .highlight {
  -webkit-animation: inputHighlighter 0.3s ease;
  -moz-animation: inputHighlighter 0.3s ease;
  animation: inputHighlighter 0.3s ease;
}

/* animation */
@-webkit-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@-moz-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}

/****  floating-Lable style end ****/

/* Floating label css ends */

/* Uploading file css */
/* .con-img-upload .img-upload{
  height:25px !important;
}
.con-input-upload{
  height:25px !important;
}
h4.text-archive{
  font-size: 13px !important
}
.con-img-upload .img-upload .btn-x-file i{
  font-size:10px !important;
}
.con-img-upload .img-upload .btn-upload-file:not(.on-progress):hover i{

    font-size: 12px !important;
    background: rgba(var(--vs-success),1);
    top: 15% !important;
    padding: 10px;
}

.vs-upload--button-upload:hover {
    padding-bottom: 0px !important;
    padding-top: 0px !important;
    background: rgba(var(--vs-primary),1);
    color: #fff;
} */
.vs-popup--background {
  opacity: 0.3 !important;
}
.con-img-upload .img-upload {
  width: 150px !important;
}

.training-header {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 1.25rem;
  margin-bottom: 2rem;
}

.training-title h6 {
  color: #2c3e50;
  font-size: 1.25rem;
  margin-bottom: 0.75rem;
  font-weight: 600;
}

.training-title small {
  color: #6c757d;
  display: block;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.question {
  background: #f8f9fa;
  padding: 2rem;
  border-radius: 10px;
  margin-bottom: 2rem;
  border: 1px solid #e9ecef;
}

.question-text {
  color: #2c3e50;
  font-size: 1.15rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
}

.options {
  padding: 0 1.5rem;
}

.options p {
  color: #6c757d;
  font-size: 0.9rem;
  margin-bottom: 1.5rem;
}

.options p i {
  color: #2196f3;
}

.options-list {
  padding: 0;
  margin: 0 0 2rem;
}

.option-item {
  margin-bottom: 1rem;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  transition: all 0.2s ease;
  border: 1px solid #e9ecef;
  display: none;
}

.option-item.active {
  display: block;
}

.option-item:hover {
  background: #f8f9fa;
  border-color: #2196f3;
}

.progress-indicator {
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
  padding: 0 1rem;
}

.progress-text {
  font-size: 0.9rem;
  color: #6c757d;
}

.progress-bar {
  height: 6px;
  background: #e9ecef;
  flex: 1;
  border-radius: 3px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: #2196f3;
  transition: width 0.3s ease;
}

.button-container {
  display: flex;
  justify-content: flex-end;
  padding: 1rem 0;
}

.next-btn {
  background: #2196f3 !important;
  border: none !important;
  padding: 0.75rem 2rem !important;
  font-weight: 500;
  letter-spacing: 0.5px;
  border-radius: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 6px rgba(33, 150, 243, 0.2);
  min-width: 180px;
}

.next-btn:hover {
  background: #1976d2 !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(33, 150, 243, 0.3);
}

.completed-message {
  text-align: center;
  padding: 3rem 1rem;
}

.completed-message i {
  color: #4caf50;
  margin-bottom: 1.5rem;
  display: block;
}

.completed-message h6 {
  color: #2c3e50;
  font-size: 1.25rem;
  font-weight: 500;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
  
  .questionScreen {
    padding: 1.5rem;
    margin: 0 1rem 2rem;
  }
  
  .container.mt-5 {
    margin-top: 1rem !important;
  }
  
  .question {
    padding: 1.5rem;
  }
  
  .options {
    padding: 0 0.5rem;
  }
  
  .button-container {
    padding: 1rem 0.5rem;
  }
  
  .next-btn {
    width: 100%;
    min-width: auto;
  }
  
  .option-item {
    padding: 0.5rem 0.75rem;
  }
  
  .option-item:hover {
    transform: none;
  }
  
  .progress-indicator {
    padding: 0;
  }
}
</style>
